<form class="container" [formGroup]="form" (ngSubmit)="$event.preventDefault()">
  <div class="title-wrap">
    <p class="title-spacing">Finalizar inversiones</p>
  </div>

  <div class="field-row field-row--payer-and-amount u-pb-1">
    <div class="field-group field-group--payer">
      <p class="field-label">Empresa pagadora</p>
      <p class="field-value field-value--payer-company">
        {{ (data?.invoice?.debtor?.companyName || '-') | uppercase }}
      </p>
    </div>
    <div class="field-group field-group--amount">
      <p class="field-label">Monto adelantado</p>
      <ng-container
        *ngIf="data?.invoice?.advanceAmount != null && data?.invoice?.advanceAmount !== ''; else advanceAmountMissing"
      >
        <p class="field-value field-value--money">
          {{ data?.invoice?.currency | currencyToSign }}&nbsp;{{
            data?.invoice?.advanceAmount | numberSpacing
          }}
        </p>
      </ng-container>
      <ng-template #advanceAmountMissing>
        <p class="field-value field-value--money">-</p>
      </ng-template>
    </div>
  </div>

  <div class="field-row">
    <div class="field-group field-group--datepicker">
      <app-date-picker
        formControlName="finalizedDate"
        label="Fecha de finalización"
      ></app-date-picker>
    </div>
  </div>

  <div class="field-row investors-section">
    <div class="field-group field-group--block">
      <p class="investments-subtitle">Selecciona las inversiones que quieres finalizar.</p>

      <div *ngIf="loadingInvestments" class="description">Cargando inversiones...</div>

      <div *ngIf="!loadingInvestments && investments.length === 0" class="description">
        No hay inversiones para esta factura.
      </div>

      <div
        *ngIf="!loadingInvestments && investments.length > 0"
        class="code-table"
        [ngClass]="investments.length > 1 ? 'small-height' : 'big-height'"
      >
        <table>
          <tr>
            <th>
              <div class="th-investor">
                <app-checkbox
                  [checked]="selectAll"
                  (selectionChanged)="onSelectAllChanged($event)"
                  content=""
                ></app-checkbox>
                <span class="th-investor__text">Inversionista</span>
              </div>
            </th>
            <th class="col-amount">Monto</th>
          </tr>
          <tr *ngFor="let investment of investments">
            <td>
              <app-checkbox
                [checked]="isInvestmentSelected(investment?._id)"
                (selectionChanged)="onToggleInvestment(investment?._id, $event)"
                [content]="getInvestorName(investment) || '-'"
              ></app-checkbox>
            </td>
            <td class="td-amount">
              {{ data?.invoice?.currency | currencyToSign }}&nbsp;{{
                getInvestmentAmount(investment) | numberSpacing
              }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div class="field-row">
    <div class="field-group field-group--summary">
      <div class="available-summary">
        <p class="field-label">Monto disponible para invertir</p>
        <p class="available-summary__value">
          {{ data?.invoice?.currency | currencyToSign }}&nbsp;{{
            availableToInvestAmount | numberSpacing
          }}
        </p>
      </div>
    </div>
  </div>

  <div class="actions actions-column">
    <fs-ui-button
      (click)="toCheckHandoff()"
      [isDisabled]="
        !form?.get('finalizedDate')?.value || selectedInvestmentIds.length === 0
      "
      [label]="'Continuar'"
      [type]="'secondary'"
    ></fs-ui-button>
    <fs-ui-button (click)="close()" [label]="'Regresar'" [type]="'tertiary'"></fs-ui-button>
  </div>
</form>
